// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ChapterAnalyticsTab — Grid layout for KPI cards and chart cards */

.chapter-analytics {
  width: 100%;
}

.chapter-analytics-kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.chapter-analytics-charts {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

@media (max-width: 900px) {
  .chapter-analytics-charts {
    grid-template-columns: 1fr;
  }
}

.chart-card {
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.06);
}

.chart-card--wide {
  grid-column: span 2;
}

@media (max-width: 900px) {
  .chart-card--wide {
    grid-column: span 1;
  }
}

.chart-card-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.9rem;
  font-weight: 700;
  color: #1A5F7A;
  margin: 0 0 14px;
}

.chart-card-canvas {
  position: relative;
  height: 280px;
}

.chart-card-canvas--small {
  height: 240px;
}

/* Time range picker */
.analytics-time-picker {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
}

/* Loading state */
.chapter-analytics-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  color: #6C757D;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/content/ChapterAnalyticsTab.css"],"names":[],"mappings":"AAAA,oEAAoE;;AAEpE;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,qCAAqC;EACrC,iBAAiB;AACnB","sourcesContent":["/* ChapterAnalyticsTab — Grid layout for KPI cards and chart cards */\n\n.chapter-analytics {\n  width: 100%;\n}\n\n.chapter-analytics-kpis {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.chapter-analytics-charts {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n@media (max-width: 900px) {\n  .chapter-analytics-charts {\n    grid-template-columns: 1fr;\n  }\n}\n\n.chart-card {\n  background: #fff;\n  border: 1px solid #E5E7EB;\n  border-radius: 14px;\n  padding: 20px;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.06);\n}\n\n.chart-card--wide {\n  grid-column: span 2;\n}\n\n@media (max-width: 900px) {\n  .chart-card--wide {\n    grid-column: span 1;\n  }\n}\n\n.chart-card-title {\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #1A5F7A;\n  margin: 0 0 14px;\n}\n\n.chart-card-canvas {\n  position: relative;\n  height: 280px;\n}\n\n.chart-card-canvas--small {\n  height: 240px;\n}\n\n/* Time range picker */\n.analytics-time-picker {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 20px;\n}\n\n/* Loading state */\n.chapter-analytics-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  color: #6C757D;\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
